import React from 'react';
import Head from './Head';
import Plan from './Plan';
import Details from './Details';
import HowToApply from './HowToApply';
import StripeLine from './StripeLine';
import Outro from './Outro';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { lighten, darken } from '@material-ui/core/styles';
import AppLayout from '../../front/Layout/AppLayout';
import AuthDialogContextProvider from '../../front/components/AuthDialog/AuthDialogContextProvider';
import Businesses from './components/Businesses';

export const anaBlue = '#0B318F';
export const anaBackgroundColor = '#E8F8FF';
export const highlightColor = '#F1DB63';

export const DYNAMIC_PACKAGE = 'https://www.ana.co.jp/ja/jp/domtour/dp/';

export const Context = React.createContext({ plans: [] });

export const anaTheme = createMuiTheme({
  palette: {
    primary: {
      light: lighten(anaBlue, 0.4),
      main: anaBlue,
      dark: darken(anaBlue, 0.1),
    },
  },
});

const Ana = ({
  plans = [],
  businesses = [],
  authenticated,
  ...headerProps
}) => {
  return (
    <AuthDialogContextProvider>
      <AppLayout {...headerProps} authenticated={authenticated}>
        <Context.Provider value={{ plans }}>
          <div style={{ overflow: 'hidden' }}>
            <Head />
            <Details />
            <Plan isAuthenticated={authenticated} />
            <HowToApply />
            <Businesses
              isAuthenticated={authenticated}
              businessesGroupedByAirport={businesses}
            />
            <StripeLine />
            <Outro />
          </div>
        </Context.Provider>
      </AppLayout>
    </AuthDialogContextProvider>
  );
};

export default Ana;
